<script setup>
import {computed, onMounted} from 'vue'
import { useCustomerStore } from '@/stores/customer.js'
import { useRoute } from 'vue-router'
import CustomerDetails from '@/components/customer/CustomerDetails.vue'
import Split from '@/layouts/split.vue'
import Comments from '@/components/Comments.vue'
import DocList from '@/components/documents/DocList.vue'
import SummaryOrgsObj from "@/components/common/SummaryOrgsObj.vue";
import ContractsList from "@/components/contract/ContractsList.vue";

const route = useRoute()
const customerStore = useCustomerStore()
const customer = computed(() => customerStore.customer)

onMounted(() => {
  customerStore.loadCustomer(route.params.id);
});

const customerId = route.params.id;
</script>
<template>
  <Split>
    <template #main>
      <CustomerDetails :customer-id="customerId" />
      <div class="flex gap-4 pt-4 flex-col lg:flex-row">
        <div class="flex flex-col gap-4 w-full lg:basis-[40%] lg:shrink-0">
          <ContractsList :customer-id="Number(customerId)" :rows-per-page="2" />
          <SummaryOrgsObj
              :inProgressObjects="customer?.objects_in_progress_count"
              :archiveObjects="customer?.objects_completed_count"
              :worksInProgress="customer?.works_in_progress_count"
              :worksCompleted="customer?.works_completed_count"
              :customer-id="Number(customerId)"
          />
        </div>
        <DocList
            class="w-full lg:basis-[60%] lg:shrink-0"
            target="customer" :entity-id="Number(customerId)"
        />

      </div>
    </template>


    <template #sidebar>
      <Comments
          class="lg:flex-1 lg:min-h-0"
          target="customer"
          :entity-id="Number(customerId)"
          :currentUserName="'Вы'"
      />
    </template>
  </Split>

</template>